var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSemanticSegmentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0H0V20H24V0ZM22 2H2V13.4118L8.5 5L12.5714 10.2689L6 18H8L16 8L22 15.5V2ZM21.4388 18L16 11.2016L10.5612 18H21.4388Z",
    fill: "#1E63F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSemanticSegmentation);
export default __webpack_public_path__ + "static/media/icon-semanticSegmentation.e4d8c4e8ffca9d3875fb67ec77dad46e.svg";
export { ForwardRef as ReactComponent };